<div class="data-table container-fluid p-0"
     cdkDropList
     [cdkDropListDisabled]="!allowDrop"
     (cdkDropListDropped)="onDrop($event)">
  <div class="header" [class.selected]="showContent" (click)="toggleContent()">
    <div class="row m-0">
      <div class="col col-5 pl-0 row-text">
        <div class="row-name">{{data.displayName}}</div>
        <div class="row-description mt-1" *ngIf="!!data.description">{{data.description}}</div>
      </div>

      <div class="col col-1 p-0">
        <span class="row-count">{{data.files.length + (data.files.length > 1 ? " FILES" : " FILE")}}</span>
      </div>

      <div class="col col-2">
        <span class="row-author uppercase">{{data.author?.name}}</span>
      </div>

      <div class="col col-2">
        <span class="row-date uppercase">{{data.createdTime | date : 'mediumDate'}}</span>
      </div>

      <div class="row-controls col col-2 pr-0">
        <a class="nav-link p-0" *ngIf="showView" (click)="onView($event)">
          <span><i class="icon icon-view" aria-hidden="true"></i></span>
        </a>
        <a class="nav-link p-0" *ngIf="allowEdit" (click)="onEdit($event)">
          <span><i class="icon icon-edit" aria-hidden="true"></i></span>
        </a>
        <a class="nav-link p-0" *ngIf="allowDelete" (click)="onDelete($event)">
          <span><i class="icon icon-trash" aria-hidden="true"></i></span>
        </a>
      </div>
    </div>
  </div>

  <div class="content" *ngIf="!!showContent">
    <div *ngFor="let file of data.files; let idx = index"
         cdkDrag
         [cdkDragDisabled]="!(allowDrop && allowItemOrder)"
         [cdkDragData]="file">
      <app-asset-data-table-item [file]="file" [index]="idx + 1" [showRowNumber]="showRowNumber" [hideDeleteButton]="!allowEdit"
        (delete)="onRemoveFile($event)" ></app-asset-data-table-item>
    </div>
  </div>
</div>
